// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page header adjustment */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.add-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-btn:hover {
  background: #4752c4;
}

.stats-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
}

.stat-card {
  background: #2f3136;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.stat-card .stat-value {
  display: block;
  font-size: 28px;
  font-weight: bold;
  color: #fff;
}

.stat-card .stat-label {
  color: #b9bbbe;
  font-size: 12px;
  text-transform: uppercase;
}

.stat-card.completed { border-left: 4px solid #43b581; }
.stat-card.pending { border-left: 4px solid #faa61a; }
.stat-card.failed { border-left: 4px solid #f04747; }
.stat-card.points { border-left: 4px solid #5865f2; }

.filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-tabs button {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.filter-tabs button.active,
.filter-tabs button:hover {
  background: #5865f2;
  color: white;
}

.tasks-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}

.task-card {
  background: #2f3136;
  border-radius: 8px;
  padding: 15px;
  border-left: 4px solid #5865f2;
}

.task-card.completed {
  border-left-color: #43b581;
  opacity: 0.8;
}

.task-card.failed {
  border-left-color: #f04747;
  opacity: 0.8;
}

.task-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.category-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
}

.category-badge.light { background: #43b581; color: white; }
.category-badge.medium { background: #faa61a; color: black; }
.category-badge.hard { background: #f04747; color: white; }
.category-badge.hardcore { background: #7c0a02; color: white; }

.status-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
}

.status-badge.pending { background: #faa61a; color: black; }
.status-badge.completed { background: #43b581; color: white; }
.status-badge.failed { background: #f04747; color: white; }

.task-title {
  color: #fff;
  margin: 0 0 8px 0;
  font-size: 16px;
}

.task-desc {
  color: #b9bbbe;
  font-size: 13px;
  margin: 0 0 10px 0;
}

.task-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 12px;
  color: #72767d;
  margin-bottom: 10px;
}

.task-meta .points {
  color: #faa61a;
  font-weight: bold;
}

.proof-badge {
  background: #5865f2;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
}

.task-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #40444b;
}

.action-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.action-btn.complete {
  background: #43b581;
  color: white;
}

.action-btn.fail {
  background: #faa61a;
  color: black;
}

.action-btn.delete {
  background: #f04747;
  color: white;
}

.no-tasks {
  text-align: center;
  color: #72767d;
  padding: 40px;
  grid-column: 1 / -1;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-group.checkbox label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.form-group.checkbox input {
  width: auto;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #40444b;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  background: #5865f2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:hover {
  background: #4752c4;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Tasks.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA,uBAAuB,8BAA8B,EAAE;AACvD,qBAAqB,8BAA8B,EAAE;AACrD,oBAAoB,8BAA8B,EAAE;AACpD,oBAAoB,8BAA8B,EAAE;;AAEpD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;AAC3D,yBAAyB,mBAAmB,EAAE,YAAY,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D,2BAA2B,mBAAmB,EAAE,YAAY,EAAE;;AAE9D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;AAC3D,0BAA0B,mBAAmB,EAAE,YAAY,EAAE;AAC7D,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;;AAE1D;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* Page header adjustment */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.add-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background: #4752c4;\n}\n\n.stats-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.stat-card {\n  background: #2f3136;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.stat-card .stat-value {\n  display: block;\n  font-size: 28px;\n  font-weight: bold;\n  color: #fff;\n}\n\n.stat-card .stat-label {\n  color: #b9bbbe;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.stat-card.completed { border-left: 4px solid #43b581; }\n.stat-card.pending { border-left: 4px solid #faa61a; }\n.stat-card.failed { border-left: 4px solid #f04747; }\n.stat-card.points { border-left: 4px solid #5865f2; }\n\n.filter-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.filter-tabs button {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.filter-tabs button.active,\n.filter-tabs button:hover {\n  background: #5865f2;\n  color: white;\n}\n\n.tasks-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 15px;\n}\n\n.task-card {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 15px;\n  border-left: 4px solid #5865f2;\n}\n\n.task-card.completed {\n  border-left-color: #43b581;\n  opacity: 0.8;\n}\n\n.task-card.failed {\n  border-left-color: #f04747;\n  opacity: 0.8;\n}\n\n.task-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.category-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.category-badge.light { background: #43b581; color: white; }\n.category-badge.medium { background: #faa61a; color: black; }\n.category-badge.hard { background: #f04747; color: white; }\n.category-badge.hardcore { background: #7c0a02; color: white; }\n\n.status-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n.status-badge.pending { background: #faa61a; color: black; }\n.status-badge.completed { background: #43b581; color: white; }\n.status-badge.failed { background: #f04747; color: white; }\n\n.task-title {\n  color: #fff;\n  margin: 0 0 8px 0;\n  font-size: 16px;\n}\n\n.task-desc {\n  color: #b9bbbe;\n  font-size: 13px;\n  margin: 0 0 10px 0;\n}\n\n.task-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  font-size: 12px;\n  color: #72767d;\n  margin-bottom: 10px;\n}\n\n.task-meta .points {\n  color: #faa61a;\n  font-weight: bold;\n}\n\n.proof-badge {\n  background: #5865f2;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n}\n\n.task-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #40444b;\n}\n\n.action-btn {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n}\n\n.action-btn.complete {\n  background: #43b581;\n  color: white;\n}\n\n.action-btn.fail {\n  background: #faa61a;\n  color: black;\n}\n\n.action-btn.delete {\n  background: #f04747;\n  color: white;\n}\n\n.no-tasks {\n  text-align: center;\n  color: #72767d;\n  padding: 40px;\n  grid-column: 1 / -1;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.form-group.checkbox label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.form-group.checkbox input {\n  width: auto;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #40444b;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #5865f2;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn:hover {\n  background: #4752c4;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
